module.exports = {
      id: "986a747fc0cf6086308de3900376ca7eroofShape-mono-pitched.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#986a747fc0cf6086308de3900376ca7eroofShape-mono-pitched.svg",
      toString: function () {
        return this.url;
      }
    }